import client from "./APIClient"

export default class Emails {
  static sendCancel = data => {
    return client("emails", {method: "POST", body: data})
  }
}
